import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RegisterPalletForm";
import {LIST_PRODUCTS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelRegisterOtherPallet} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "palletId");
  errors = validatePresence(errors, values, "inventorySku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class RegisterOtherPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.registerPallet(values.toJS())
      .then((response) => {
        if (response.data.registerPallet.errors.length <= 0) {
          this.props.cancelRegisterOtherPallet();
        } else {
          let errors = createValidationErrors(response.data.registerPallet.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRegisterOtherPallet();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />     
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        products={fromJS(data.products)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const REGISTER_PALLET = gql`
  mutation registerPallet($data: PalletInput!) {
    registerPallet(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(LIST_PRODUCTS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        type: "dispenser_and_packaging"
      }
    })
  }),  
  graphql(REGISTER_PALLET, {
    props: ({ mutate }) => ({
      registerPallet: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelRegisterOtherPallet})(withQueries(RegisterOtherPalletFormContainer));